import {
	ChangeDetectorRef,
	Component,
	EventEmitter,
	ViewChild
} from '@angular/core';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { TranslateService } from '@ngx-translate/core';
import { TapticEngine } from '@ionic-native/taptic-engine';
import {
	ActionSheetController,
	ModalController,
	NavController,
	NavParams,
	Platform,
	ToastController
} from 'ionic-angular';
import { ConfigProvider } from '../../../../providers/config/config';
import { LoaderProvider } from '../../../../providers/loader/loader';
import { MyPicsListModel, UserProvider } from '../../../../providers/user/user';
import {
	PicturePagerEvent,
	PictureViewerPage
} from '../../../picture-viewer/picture-viewer';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { SessionProvider } from '../../../../providers/session/session';

/**
 * Generated class for the MysportPhotosPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
	selector: 'page-mysport-photos',
	templateUrl: 'mysport-photos.html'
})
export class MysportPhotosPage {
	pictures: MyPicsListModel[] = [];
	activeIndex?: number = null;

	@ViewChild('uploadButton')
	uploadButton: any;

	/*
	// we use read only to disable add/delete/edit functionality when we come from User Menu page.
	*/
	readOnly: boolean = false;

	/*
	// we use shirts to disable add button and show the t-shirt button to forward the user to the shop.
	*/
	shirts: boolean = false;

	/*
	// 3 types of photo page: user's photos, bibs and shirts
	*/
	type: string = "";

	// UI

	/*
	// title: depends on the type 
	*/
	title: string = "";

	/*
	// no photo message depends on the type
	*/
	noPhotoMessage: string = "";

	/*
	// if the user comes from the feed page, then we use another endpoint to upload the photo
	*/
	routeEndpoint: boolean = false;

	/*
	// if the user comes from the feed page
	*/
	routeName: string = "";

	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		private userService: UserProvider,
		private actionSCtrl: ActionSheetController,
		private loadingCtrl: LoaderProvider,
		private camera: Camera,
		public translate: TranslateService,
		private changeDetector: ChangeDetectorRef,
		private config: ConfigProvider,
		public modalCtrl: ModalController,
		private taptic: TapticEngine,
		private platform: Platform,
		private iab: InAppBrowser,
		private sessionService: SessionProvider,
		private toastCtrl:ToastController
	) {
		this.pictures = navParams.data.pictures;
		this.readOnly = navParams.data.readOnly;
		this.shirts = navParams.data.shirts;
		this.type = navParams.data.type;
		this.routeName = navParams.data.routeName;

		this.updateUI();
	}

	updateUI() {
		if (this.type.includes('photos')) {
			this.title = this.translate.instant('MYSPORT_PHOTOS_TITLE');
			this.noPhotoMessage = this.translate.instant('GLOBAL_NO_UPLOADED_PHOTOS');
		} else if (this.type.includes('bibs')) {
			this.title = this.translate.instant('MYSPORT_BIBS_TITLE');
			this.noPhotoMessage = this.translate.instant('GLOBAL_NO_UPLOADED_BIBS');
		} else if (this.type.includes('shirts')) {
			this.title = this.translate.instant('MYSPORT_SHIRTS_TITLE');
			this.noPhotoMessage = this.translate.instant('GLOBAL_NO_UPLOADED_SHIRTS');
		} else if (this.type.includes('route-image')) {
			this.title = this.translate.instant('MYSPORT_PHOTOS_TITLE');
			this.noPhotoMessage = this.translate.instant('GLOBAL_NO_UPLOADED_PHOTOS');
			this.routeEndpoint = true;
		} else if (this.type.includes('route-no-button')) {
			this.title = this.translate.instant('MYSPORT_PHOTOS_TITLE');
			this.noPhotoMessage = this.translate.instant('GLOBAL_NO_UPLOADED_PHOTOS');
			this.readOnly = true;
		} else if (this.type.includes('route-no-pics')) {
			this.title = this.translate.instant('MYSPORT_PHOTOS_TITLE');
			this.noPhotoMessage = this.translate.instant('GLOBAL_NO_PHOTOS');
			this.routeEndpoint = true;
		}
	}

	picTap(picture, index) {
		console.log('picTap')

		let emitter = new EventEmitter();
		let deleteEmitter = new EventEmitter();
		emitter.subscribe(event => {
			this.pictureRotated(event);
		});
		deleteEmitter.subscribe((data) => this.removePicture(data));

		let photoModal = this.modalCtrl.create(PictureViewerPage, {
			emitter: emitter,
			emitter1: deleteEmitter,
			pictures: this.pictures,
			activeIndex: index,
			icon: (!this.readOnly) ? 'refresh' : '',
			icon1: (!this.readOnly) ? 'trash' : ''
		});
		photoModal.present();
		photoModal.onDidDismiss(() => {
			emitter.unsubscribe();
			deleteEmitter.unsubscribe();
		});

		// (this.app.getRootNav() as NavController).push(PictureViewerPage, {
		//   emitter: emitter,
		//   pictures: this.pictures,
		//   activeIndex: index,
		//   icon: "refresh"
		// })
	}

	shopRedirect() {
		let browser = this.iab.create("http://spooorts.shop", '_blank', 'location=yes');
		browser.show();
	}

	async pictureRotated(event: PicturePagerEvent) {
		let loader = this.loadingCtrl.create({
			content: this.translate.instant('GLOBAL_LOADING')
		});
		await loader.present();
		let model = event.list[event.index];

		let base64ImageSrc = model.imageLink;
		let that = this;
		let img = new Image();
		img.setAttribute('crossOrigin', 'anonymous');

		img.onload = async () => {
			let c = document.createElement('canvas');
			c.width = img.height;
			c.height = img.width;
			let ctx = c.getContext('2d');
			ctx.rotate((90 * Math.PI) / 180);
			ctx.drawImage(img, 0, -img.height);
			let base = c.toDataURL();

			if (base.length > 6) {
				this.sessionService.getToken().then(async token => {
					let photo = await that.userService.createPhoto(model.id, base, that.routeEndpoint);
					that.userService.removePhoto(model.id, that.routeEndpoint, token, that.routeName);
					event.list[event.index] = photo as any;
					that.changeDetector.markForCheck();
					that.changeDetector.detectChanges();
				});
			}
			loader.dismiss();
		};
		img.src = base64ImageSrc;
	}

	picPress(picture) {
		console.log('picPress');

		let sheet = this.actionSCtrl.create({
			title: this.translate.instant('MYSPORT_PHOTOS_SHEET_TITLE'),
			buttons: [
				{
					text: this.translate.instant('MYSPORT_PHOTOS_SHEET_DELETE'),
					role: 'destructive',
					handler: () => {
						this.removePicture(picture);
					}
				},
				{
					text: this.translate.instant('MYSPORT_PHOTOS_SHEET_CANCEL'),
					role: 'cancel',
					handler: () => {
						console.log('Cancel clicked');
					}
				}
			]
		});
		if (window['TapticEngine'] && this.platform.is('ios')) {
			this.taptic.selection();
		}
		sheet.present();
	}

	removePicture(data: any) {
		let picture: MyPicsListModel = data.list[data.index];
		console.log('delete', picture);
		let loader = this.loadingCtrl.create({
			content: this.translate.instant('GLOBAL_LOADING')
		});
		loader.present();
		this.sessionService.getToken().then(token => {
			this.userService.removePhoto(picture.id, this.routeEndpoint, token, this.routeName).then(success => {
				if (success) {
					this.pictures = this.pictures.filter(x => x.id !== picture.id);
				}
				loader.dismiss();
			});
		})
	}

	ionViewDidLoad() {
		console.log();
		this.config.config.then(conf => {
			if (conf.platform.browser) {
				this.createFileInput();
			}
		});
	}
	presentToast(message, position, cssclass) {
		let toast = this.toastCtrl.create({
		  message: message,
		  cssClass: cssclass,
		  position: position,
		  duration: 10000
		});
		toast.present();
	}
	fileInputClick() {
		const allowed = localStorage.getItem('isPhotoUploadAllowedKey')
		if (!allowed && this.platform.is('android')) {
			this.presentToast(this.translate.instant("IMAGE_DENIED"), 'bottom', "permission-sheet");
		} else {
			const options: CameraOptions = {
				quality: 80,
				destinationType: this.camera.DestinationType.DATA_URL,
				encodingType: this.camera.EncodingType.JPEG,
				mediaType: this.camera.MediaType.PICTURE,
				sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
				correctOrientation: true
			};
			this.camera
				.getPicture(options)
				.then(photo => {
					this.addNewPicture('data:image/jpeg;base64,' + photo);
				})
				.catch();
		}
	}

	addNewPicture(data) {
		let loader = this.loadingCtrl.create({
			content: this.translate.instant('GLOBAL_LOADING')
		});
		loader.present();
		console.log('data: ' + data);
		const imageParts = data.split('base64,');
		const payload = imageParts[1];
		this.sessionService.getToken().then(token => {
			this.userService.uploadMyPhoto({
				id: new Date().getTime(),
				imageLink: payload,
				name: "pic" + new Date().getTime() + ".jpeg"
			},
				token).then(res => {
					console.log('res',res);
					this.pictures.push({
						id: new Date().getTime(),
						imageLink: payload
					})
					console.log('this.pictures', this.pictures)
					loader.dismiss();
				}).catch(err => {
					console.error(err);
					loader.dismiss();
				});
			// this.userService.createPhoto(-1, data, this.routeEndpoint, token, this.routeName).then((data: any) => {
			// 	this.pictures.push(data);
			// 	loader.dismiss();
			// });
		})
	}

	async createFileInput() {
		if (!(await this.config.config).platform.browser) return;

		if (document.querySelector('.cordova-camera-select')) return;
		try {
			const options: CameraOptions = {
				quality: 100,
				destinationType: this.camera.DestinationType.DATA_URL,
				encodingType: this.camera.EncodingType.JPEG,
				mediaType: this.camera.MediaType.PICTURE,
				sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
				correctOrientation: true
			};
			this.camera
				.getPicture(options)
				.then(photo => {
					// 					this.addNewPicture('data:image/jpeg;base64,' + photo);
					// 					this.createFileInput();
				})
				.catch();
			var input = document.querySelector(
				'.cordova-camera-select'
			) as HTMLElement;
			document.body.removeChild(input);
			console.log(this.uploadButton);
			input.style.opacity = 0 + '';
			input.style.position = 'fixed';
			input.style.height = '100%';
			console.log(this.uploadButton);
			let button = this.uploadButton.getNativeElement() as HTMLElement;
			button.parentElement.insertBefore(input, button);
		} catch {
			//this.model.img = "data:image/png;base64,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";
		}
	}
}



// WEBPACK FOOTER //
// /src/pages/me/mysport/mysport-photos/mysport-photos.ts